import styled from "styled-components";

// ── Colour tokens ────────────────────────────────────────────────────────────

export const TIMELINE_COLORS = {
  completed: "#38A97A",
  inProgress: "#38A97A",
  pending: "#e2e2e2",
  error: "#EB2026",
} as const;

// ── Vertical layout ──────────────────────────────────────────────────────────

export const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const VerticalItemContainer = styled.div<{
  itemGap: number;
  isLast: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  ${({ isLast, itemGap }) => !isLast && `margin-bottom: ${itemGap}px;`}
`;

export const VerticalRail = styled.div<{
  markerSize: number;
  contentGap: number;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  position: relative;
  width: ${({ markerSize }) => markerSize}px;
  margin-right: ${({ contentGap }) => contentGap}px;
`;

export const VerticalConnector = styled.div<{
  connectorWidth: number;
  color: string;
  itemGap: number;
}>`
  flex: 1;
  width: ${({ connectorWidth }) => connectorWidth}px;
  background-color: ${({ color }) => color};
  border-radius: 999px;
  min-height: 4px;
  margin-bottom: ${({ itemGap }) => -itemGap}px;
`;

// ── Horizontal layout ────────────────────────────────────────────────────────

export const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-start;
`;

export const HorizontalItemContainer = styled.div<{
  itemGap: number;
  isLast: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  ${({ isLast, itemGap }) => !isLast && `margin-right: ${itemGap}px;`}
`;

export const HorizontalRail = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export const HorizontalConnector = styled.div<{
  connectorWidth: number;
  color: string;
}>`
  flex: 1;
  height: ${({ connectorWidth }) => connectorWidth}px;
  background-color: ${({ color }) => color};
  border-radius: 999px;
`;

// ── Shared ───────────────────────────────────────────────────────────────────

export const ContentContainer = styled.div`
  flex: 1;
  min-width: 0;
`;

export const HorizontalContentContainer = styled.div`
  width: 100%;
  margin-top: 6px;
`;

export const DefaultMarker = styled.div<{
  size: number;
  borderColor: string;
  bgColor: string;
}>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  border: 2px solid ${({ borderColor }) => borderColor};
  background-color: ${({ bgColor }) => bgColor};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const MarkerInnerDot = styled.div<{ size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  background-color: #fff;
`;
